export default "__VITE_ASSET__CrZ7VCCw__"